// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ASK_AN_EXPERT = "Poradny";
export const BAZAAR = "Bazar";
export const BLOGS_WALL = "P\u0159\u00edsp\u011bvky";
export const CONTESTS = "Sout\u011b\u017ee";
export const FORUMS_AND_GROUPS = "Diskuze a skupiny";
export const LOG_IN = "P\u0159ihlas se";
export const MAGAZINE = "Magaz\u00edn";
export const MAIN_MENU_REVIEWS = "Recenze";
export const REGISTER_HERE = "Zaregistruj se zde!";
export const SERVER_FULL_NAME = "Modr\u00fd kon\u00edk";
export const SERVER_SLOGAN = "Modr\u00fd kon\u00edk \u2022 Skute\u010dn\u00ed lid\u00e9. Skute\u010dn\u00fd \u017eivot. Re\u00e1ln\u00e9 zku\u0161enosti.";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00e1rkopedie";
